<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Πελάτες Τιμολογίου</h4>
          <CButton class="m-3" color="primary" @click="createInvoiceClient()">Προσθήκη πελάτη τιμολογίου</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            :loading="loading"
            sorter
          >
          
          <template #show="{item}">
            <td>
              <CButton color="primary" @click="showInvoiceClient( item.id )">Προβολή</CButton>
            </td>
          </template>
          <template #edit="{item}">
            <td>
              <CButton color="primary" @click="editInvoiceClient( item.id )">Επεξεργασία</CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  {
    key: 'client_code', 
    label: 'Κωδικός', 
    sorter: true, 
    filter: true
  },
  {
    key: 'company', 
    label: 'Επωνυμία Εταιρίας', 
    sorter: true, 
    filter: true
  },
  {
    key: 'address', 
    label: 'Διεύθυνση', 
    sorter: true, 
    filter: true
  },
  {
    key: 'phone_number_1', 
    label: 'Τηλέφωνο', 
    sorter: true, 
    filter: true
  }, 
  {
    key: 'afm', 
    label: 'ΑΦΜ', 
    sorter: true, 
    filter: true
  },
  { 
    key: 'show', 
    label: '', 
    sorter: false, 
    filter: false
  },
  { 
    key: 'edit', 
    label: '', 
    sorter: false, 
    filter: false
  }
]

export default {
  name: 'InvoiceInvoiceClients',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      loading: true,
      showMessage: false,
      alertIsShown: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    InvoiceClientLink (id) {
      return `invoiceClients/${id.toString()}`
    },
    editLink (id) {
      return `invoiceClients/${id.toString()}/edit`
    },
    showInvoiceClient ( id ) {
      const InvoiceClientLink = this.InvoiceClientLink( id );
      this.$router.push({path: InvoiceClientLink});
    },
    editInvoiceClient ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getInvoiceClients (){
      let self = this;
      axios.get('/api/invoiceclients?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.invoiceclient.map((item) => {
          return item;
        });

        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    createInvoiceClient () {
      this.$router.push({path: 'invoiceClients/create'});
    },
  },
  mounted: function(){
    this.getInvoiceClients();
  }
}
</script>
